<template>
  <BtnToggle 
    ref="tool"
    :class="{ active: active }"
    :title="$t('engine.manageText.modalWidget.tooltip.lblBold', languageEngine)"
    @click="onClick(!value)"
  >
    <i class="fas fa-bold fs-16"></i>
  </BtnToggle>
</template>

<script>
import { mapGetters } from "vuex";
import BtnToggle from "./_BtnToggle";

export default {
  components: {
    BtnToggle,
  },
  data() {
    return {
      active: false,
    }
  },
  computed: {
    ...mapGetters({
      languageEngine: "designIframe/userPreference/languageEngine",
      texteditor: "designIframe/texteditor/texteditor",
    }),
    selectionFormatTemplate() {
      return this.texteditor.selectionFormatTemplate;
    },
    selectionFormatMerge() {
      return this.texteditor.selectionFormatMerge;
    },
    value() {
      if (this.selectionFormatMerge.fontWeight == 'unset') return false;
      if (this.selectionFormatMerge.fontWeight == 'normal') return false;
      if (this.selectionFormatMerge.fontWeight == 'bold') return true;
      return Boolean(this.selectionFormatMerge.bold);
    },
  },
  methods: {
    onClick(value) {
      this.active = !this.active;

      if (value) {
        this.texteditor.editor.format("bold", true);
        this.texteditor.editor.format("fontWeight", false);
      } else if (!value && this.selectionFormatTemplate.fontWeight == 'bold') {
        this.texteditor.editor.format("bold", false);
        this.texteditor.editor.format("fontWeight", 'normal');
      } else {
        this.texteditor.editor.format("bold", false);
        // this.texteditor.editor.format("fontWeight", false);
        this.texteditor.editor.format("fontWeight", 'normal');
      }
    }
  },
  mounted() {
    this.active = this.value;
  },
  watch: {
    value() {
      this.active = this.value;
    }
  },
}
</script>
